import { useState } from "react";
import { Loader2, Search } from "lucide-react";
import { DocLink, ModelRow } from "@/components/create/ModelPicker";
import { StudioHeader } from "@/components/create/explore/StudioHeader";
import { matches, useHfCatalog } from "@/lib/studio";
import { cn } from "@/lib/utils";

const FILTERS = [
  { key: "all", label: "All", test: () => true }, { key: "image", label: "Image", test: (m) => m.kind === "image" },
  { key: "video", label: "Video", test: (m) => m.kind === "video" }, { key: "available", label: "Ready", test: (m) => m.status === "available" },
  { key: "price_pending", label: "Price pending", test: (m) => m.status === "price_pending" }, { key: "unverified", label: "Unverified", test: (m) => m.status === "unverified" },
];

export default function ModelsPage() {
  const cat = useHfCatalog();
  const [filter, setFilter] = useState("all");
  const [q, setQ] = useState("");
  const all = cat.data?.models || [];
  const shown = all.filter(FILTERS.find((f) => f.key === filter).test).filter((m) => !q.trim() || matches(q.trim().toLowerCase(), m.family, m.workflow, m.operation, m.id));
  return (
    <div className="h-full overflow-y-auto" data-testid="models-page">
      <StudioHeader title="Models" back />
      <div className="mx-auto w-full max-w-6xl space-y-4 px-4 pb-20 pt-5 sm:px-6 sm:pt-8">
        <p className="text-sm text-zinc-400">Every documented model, checked {cat.data?.verified_at || "—"} with the connected account. Ready models have a confirmed price; the rest stay visible with their status.</p>
        <label className="flex h-11 items-center gap-2 rounded-full border border-white/10 bg-ink-900 px-4">
          <Search className="h-4 w-4 text-zinc-500" />
          <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search models" aria-label="Search models" data-testid="models-search-input" className="min-w-0 flex-1 bg-transparent text-sm text-white placeholder:text-zinc-600 focus:outline-none" />
        </label>
        <div className="flex flex-wrap gap-2" role="tablist" data-testid="models-filters">
          {FILTERS.map((f) => (
            <button key={f.key} type="button" role="tab" aria-selected={filter === f.key} onClick={() => setFilter(f.key)} data-testid={`models-filter-${f.key}`}
              className={cn("h-8 rounded-full px-3.5 text-xs font-medium transition-colors", filter === f.key ? "bg-white text-ink-950" : "border border-white/10 text-zinc-400 hover:text-zinc-100")}>
              {f.label} <span className="ml-1 opacity-60">{all.filter(f.test).length}</span>
            </button>
          ))}
        </div>
        {cat.isLoading && <div className="flex h-40 items-center justify-center text-zinc-500"><Loader2 className="h-5 w-5 animate-spin" /></div>}
        <div className="grid gap-2 sm:grid-cols-2" data-testid="models-grid">
          {shown.map((m) => <div key={m.id} className="space-y-1"><ModelRow m={m} /><div className="px-1"><DocLink m={m} /></div></div>)}
        </div>
      </div>
    </div>
  );
}
